"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDOMNodeCallbackRef = void 0;
const react_1 = require("react");
function useDOMNodeCallbackRef(onSet, cleanup) {
    const ref = react_1.useRef(null);
    const setRef = react_1.useCallback(node => {
        if (ref.current && cleanup) {
            // Make sure to cleanup any events/references added to the last instance
            cleanup(ref.current);
        }
        if (node) {
            onSet(node);
        }
        // Save a reference to the node
        ref.current = node;
    }, [onSet, cleanup]);
    return [setRef];
}
exports.useDOMNodeCallbackRef = useDOMNodeCallbackRef;
//# sourceMappingURL=useDOMNodeCallbackRef.js.map